export function simulationsTooltip(data, currency, formatNumber, baseCurrency) {
  let txt = baseCurrency.isCurrency ? "rate" : "price";
  return (
    "<table class='table table-borderless table-sm text-left table-analytics'>\n" +
    "  <thead>\n" +
    "    <tr style='border-bottom: 1px solid var(--lightbackground);" +
    "  background: var(--lightbackground-alpha)'>\n" +
    "      <th colspan='2'>Simulation Results (" +
    "<span style='color: var(--textactive)'>" +
    currency.toUpperCase() +
    "</span>)" +
    "  </th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr>\n" +
    "      <th style='width: 70%'>Simulation #</th>\n" +
    "      <td style='width: 30%'>" +
    Math.round(5 * data.index) +
    "   </td>\n" +
    "    </tr>\n" +
    "    <tr style='border-bottom: 1px solid var(--lightbackground)'>\n" +
    "      <th >Simulated " +
    txt +
    " </th>\n" +
    "      <td style='color:var(--symmetry-h)!important; font-size: 1rem!important;'>" +
    formatNumber(data.rates) +
    "   </td>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th>Hedged " +
    txt +
    " </th>\n" +
    "      <td style='color:var(--hedge-h)!important; font-size: 1rem!important;'>" +
    formatNumber(data.result) +
    "   </td>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th>Difference</th>\n" +
    "      <td>" +
    formatNumber(data.rates - data.result) +
    "   </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>"
  );
}
